export function select (context, { result, replace = false }) {
  context.commit('selectResult', result)
  const router = this.$router
  const go = (replace ? router.replace : router.push).bind(router)

  if (result.origin === 'google') {
    result.layer.openPopup()
  } else if (result.origin === 'coordinates') {
    const params = {
      epsg: '4326',
      coords: result.coords
    }
    go({ name: 'coords', params })
  } else {
    const params = {
      q: result.title
    }
    go({ name: 'place', params })
  }
}
